function Footer({title,subtitle}) { return(
   <footer className="footer">
    <div className="content has-text-centered is-flex-align-items-flex-end mt-auto">
        <p>
            <strong>Daniel R Moreland</strong> - Full-Stack Software Engineer - daniel.r.moreland@gmail.com
        </p>
        <p>(270) 970-9550</p>
    </div>
   </footer>
    
        )
        }
    export default Footer;
    
    